module.exports = __webpack_public_path__ + "static/coral-reef-awareness-ii-5a6b23b90718dacb6ba4432d822609a7.jpg";